module.exports = __webpack_public_path__ + "assets/media/client_training_5sec.902af679.mp3";